import request from "@/utils/request.js"

export function cailiaofei(parm){
    return request.get("/cailiaozhangdan/cailiaofei",{
        params:parm
    })
}
export function cailiaoexport(parm){
    return request.get("/contract/cailiaodan/export",{
        params:parm
    })
}
export function cailiaosum(parm){
    return request.get("/cailiaozhangdan/cailiaosum",{
        params:parm
    })
}
export function getList(parm){
    return request.get("/cailiaozhangdan",{
        params:parm
    })
}

export function addCLzhangdan(parm){
    return request.post("/cailiaozhangdan",{
        data:parm
    })
}
export function updateCLzhangdan(parm){
    return request.put("/cailiaozhangdan",{
        data:parm
    })
}
export function deleteCLzhangdan(parm){
    return request.delete("/cailiaozhangdan",{
        params:parm
    })
}



